import { decodeJWT } from "aws-amplify/auth";
import AppStorage from "./AppStorage";

class AuthHelper {

    private readonly clientId = process.env.REACT_APP_AWS_POOL_WEB_CLIENT_ID;
    private readonly cognitoPrefix = 'CognitoIdentityServiceProvider';

    private lastAuthUser: string | null;
    private refreshToken: string | null = null;
    private idToken: string | null = null;
    private accessToken: string | null = null;

    private appStorage: AppStorage;

    constructor() {
        this.appStorage = new AppStorage();
        this.lastAuthUser = this.getLastAuthUser();
    }

    private getStorageKey(keyName: string): string | null {
        if (!this.lastAuthUser || !this.clientId) return null;
        return `${this.cognitoPrefix}.${this.clientId}.${this.lastAuthUser}.${keyName}`;
    }

    private getStorageValue(keyName: string): string | null {
        const storageKey = this.getStorageKey(keyName);
        return storageKey ? this.appStorage.get(storageKey) : null;
    }

    getAccessToken(): string | null {
        if (!this.accessToken) {
            this.accessToken = this.getStorageValue('accessToken');
        }
        return this.accessToken;
    }

    getIdToken(): string | null {
        if (!this.idToken) {
            this.idToken = this.getStorageValue('idToken');
        }
        return this.idToken;
    }

    getRefreshToken(): string | null {
        if (!this.refreshToken) {
            this.refreshToken = this.getStorageValue('refreshToken');
        }
        return this.refreshToken;
    }

    getLastAuthUser(): string | null {
        const storageKey = `${this.cognitoPrefix}.${this.clientId}.LastAuthUser`;
        return this.appStorage.get(storageKey);
    }

    decodeTokenId(): any {
        const idToken = this.getIdToken();

        // Check if the idToken is available
        if (!idToken) {
            return null;
        }

        const decodedToken = decodeJWT(idToken);
        return decodedToken.payload;
    }


}

export default AuthHelper;
